
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M2.434 8.035a.746.746 0 00-.74.751c0 .415.331.752.74.752h2.398v2.437c0 .415.332.752.74.752.409 0 .74-.337.74-.752V9.538H8.71c.408 0 .74-.337.74-.752a.746.746 0 00-.74-.751h-2.4V5.598a.746.746 0 00-.739-.752.746.746 0 00-.74.752v2.437z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M6.098.082c-1.489 0-2.711 1.242-2.711 2.754v1.001c0 .415.33.751.74.751a.745.745 0 00.738-.75V2.835c0-.7.543-1.253 1.233-1.252l4.545.004s.023 1.6.023 2.398c0 1.512 1.222 2.754 2.71 2.754h1.84v8.587c0 .7-.543 1.252-1.233 1.252H6.098a1.23 1.23 0 01-1.233-1.252v-.473a.745.745 0 00-.739-.751.745.745 0 00-.74.751v.473c0 1.513 1.223 2.755 2.712 2.755h7.885c1.489 0 2.711-1.242 2.711-2.755V5.922a2.78 2.78 0 00-.693-1.838L13.279.997a2.695 2.695 0 00-2.02-.915zm6.047 1.903s1.888 2.16 2.812 3.253h-1.58a1.23 1.23 0 01-1.232-1.252z"}})])
          )
        }
      }
    